function applyTitleReplacements(str) {
  if (str == null) return "";
  const raw = window.titleReplacements;
  if (!raw) return str;
  return raw.trim().split(`\n`).reduce((out, line) => {
    const parts = line.trim().split(`|`);
    if (parts.length !== 2) return out;
    const find    = parts[0].trim().toLowerCase();
    const replace = parts[1].trim();
    if (!find || !replace) return out;
    return out.replaceAll(find, `<span style="text-transform:none">${replace}&nbsp;</span>`);
  }, str);
}

function formatProductTitle(title, upcaseValues = []) {
  if (title == null) return "";
  let out = title.toLowerCase();
  (window.leagueHandles || []).forEach(h => { out = out.replaceAll(h, h?.toUpperCase()); });
  upcaseValues.forEach(v => { out = out.replaceAll(v?.toLowerCase(), v?.toUpperCase()); });
  out = out.replaceAll("'47", "&#8217;47");
  return applyTitleReplacements(out);
}

let keyboardUser = false;
document.addEventListener('keydown', e => { if (e.key === 'Tab') keyboardUser = true; }, { capture: true });
document.addEventListener('pointerdown', () => { keyboardUser = false; }, { capture: true });
document.documentElement.style.setProperty(
  '--scrollbar-width',
  (window.innerWidth - document.documentElement.clientWidth) + 'px'
);

function trapFocus(modal, { focusDelay = 0 } = {}) {
  const selector = `a[href], area[href], input:not([disabled]),
    select:not([disabled]), textarea:not([disabled]),
    button:not([disabled]), [tabindex]:not([tabindex="-1"])`;
  const focusable = Array.from(modal.querySelectorAll(selector));
  if (!focusable.length) return;

  const first = focusable[0];
  const last  = focusable[focusable.length - 1];

  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { last.focus(); e.preventDefault(); }
    } else {
      if (document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  }

  modal.addEventListener('keydown', handleFocusTrap);
  if (keyboardUser && !modal.contains(document.activeElement)) {
    if (focusDelay > 0) {
      setTimeout(() => first.focus(), focusDelay);
    } else {
      first.focus();
    }
  }

  return () => modal.removeEventListener('keydown', handleFocusTrap);
}


function reloadJudgeme() {
  if (window.jdgm && window.jdgm.loadJS && window.jdgm.CDN_HOST) {
    window.jdgm.loadJS(window.jdgm.CDN_HOST + "loader.js");
  }
}

const addToCart = async (productForm) => {
  const formData = new FormData(productForm);
  if (window.minicartSectionId) formData.append('sections', window.minicartSectionId);

  return fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    body: formData,
  })
    .then(res => res.json())
    .then(json => json)
    .catch(err => console.error(err));
};

window.addEventListener('click', e => {
  const btn = e.target.closest('[data-atc-btn]');
  if (!btn) return;
  const productForm = btn.closest('form');
  if (!productForm) return;

  let valid = true;
  productForm.querySelectorAll('fancy-select[data-required]').forEach(fs => {
    if (!fs.value) {
      valid = false;
      const err = fs.nextElementSibling;
      err?.classList.contains('fs-error') && err.classList.remove('hidden');
      fs.classList.add('fs-error-state');
    }
  });
  if (!valid) return;

  window.dispatchEvent(new CustomEvent('modal:openById', { detail: 'minicart' }));
  const loadingWrapper = document.querySelector('[data-cart-loading-wrapper]');
  loadingWrapper?.classList.add('loading');

  // Enforce minimum loading duration so the spinner is visible even on fast connections —
  // the modal animates in (~300ms) so without this the loader clears before it's seen.
  const min_ms = 500;
  const start  = Date.now();

  addToCart(productForm)
    .then(cart => {
      const delay = Math.max(0, min_ms - (Date.now() - start));
      setTimeout(() => window.dispatchEvent(new CustomEvent('productForm:add', { detail: cart })), delay);
    })
    .catch(err => {
      loadingWrapper?.classList.remove('loading');
      alert(`Unable to add the product to cart. Please refresh and try again.\n\n${err}`);
    });
});

// Tooltip
(() => {
  function positionTooltip(popup, trigger) {
    const maxWidth    = Math.min(256, window.innerWidth - 32);
    popup.style.maxWidth = maxWidth + 'px';

    const popupWidth  = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;
    const triggerRect = trigger.getBoundingClientRect();
    const centerX     = triggerRect.left + triggerRect.width / 2;
    const top         = triggerRect.top + window.scrollY - popupHeight - 8;
    const desiredLeft = centerX - popupWidth / 2;
    const left        = Math.max(16, Math.min(desiredLeft, window.innerWidth - 16 - popupWidth));

    popup.style.top  = top + 'px';
    popup.style.left = left + 'px';
  }

  function triggerTooltip(trigger) {
    const existing = document.querySelector('[data-tooltip-popup]');
    if (existing) { existing.remove(); return; } // toggle off if same tooltip open
    const id      = trigger.dataset.tooltip;
    const content = document.querySelector(`template[data-tooltip-content="${id}"]`)?.innerHTML;
    if (!content) return;

    const popup = document.createElement('div');
    popup.dataset.tooltipPopup = '';
    popup.innerHTML = content;
    popup.style.position = 'absolute';
    document.body.appendChild(popup);
    positionTooltip(popup, trigger);

    trigger.addEventListener('blur', () => popup.remove(), { once: true });
  }

  document.addEventListener('click', e => {
    if (!e.target?.closest) return;
    const trigger = e.target.closest('[data-tooltip]');
    if (trigger) { e.stopPropagation(); e.preventDefault(); triggerTooltip(trigger); return; }
    document.querySelectorAll('[data-tooltip-popup]').forEach(p => p.remove());
  }, true);
})();

(function() {
  var portals = document.querySelectorAll('[data-cart-page-portal]');
  var main = document.getElementById('MainContent');
  if (!portals.length || !main) return;
  main.prepend(portals[0]);
  for (var i = 1; i < portals.length; i++) portals[i].remove();
})();

document.addEventListener('click', e => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute('href').slice(1);
  if (!id) return;
  const target = document.getElementById(id);
  if (!target) return;
  e.preventDefault();

  const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  const scrollGap = 24;
  const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - scrollGap;
  window.scrollTo({ top, behavior: 'smooth' });
  history.pushState(null, '', `#${id}`);
});

if (!document.referrer.includes('collection')) {
  sessionStorage.removeItem('scrollPosition');
  sessionStorage.removeItem('collectionName');
}

window.addEventListener('load', function() {
  var dialog = document.querySelector('.osano-cm-window__dialog');
  if (dialog) dialog.classList.add('is-ready');
});
